import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=4977f107&scoped=true"
var script = {}
import style0 from "./UploadIcon.vue?vue&type=style&index=0&id=4977f107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977f107",
  null
  
)

export default component.exports